import { gql } from 'apollo-angular';

export const GET_USER = gql`
  query user($id: Long!) {
    user(id: $id) {
      id
      firstName
      lastName
      emailAddress
      mobilePhone
      fax
    }
  }
`;

export type GetUserVariables = {
  id: number;
};
